import axios from "axios";
// import { REACT_APP_API_URL } from "../api/global";

export const authenticateUser = async (email, password) => {
  console.log(
    process.env.REACT_APP_API_URL,
    "live api url ********************************************************"
  );
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/login`,
      {
        email,
        password,
      }
    );

    const token = response?.data;

    return token;
  } catch (error) {
    throw new Error("Authentication failed");
  }
};

export const registerUser = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL_USER}/register`,
      {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        password: data.password,
        phoneNumber: data.phoneNumber,
      }
    );

    const resData = response?.data;

    return resData;
  } catch (error) {
    if (error.response) {
      throw new Error(error?.response?.data?.message);
    } else {
      throw new Error("Registeration failed");
    }
  }
};

export const loginUserApi = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL_USER}/login`,
      {
        email: data.email,
        password: data.password,
      }
    );

    const resData = response?.data;

    return resData;
  } catch (error) {
    if (error?.response?.data) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Please try again!");
    }
  }
};

export const skipUser = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL_USER}/skipRegister`
    );

    const resData = response?.data;

    return resData;
  } catch (error) {
    if (error?.response?.data) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Please try again!");
    }
  }
};


export const loginGuestUser = async(deviceId)=>{
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL_USER}/login-as-guest`,{deviceId }
    );

    const resData = response?.data;

    return resData;
  } catch (error) {
    if (error?.response?.data) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Please try again!");
    }
  }
}